import React from "react";
import { Formik } from "formik";
import { useSelector } from "react-redux";

import ReportNoteSectionInputForm from "./ReportNoteSectionInputForm";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";

import { ReportNoteSectionSchema } from "schemas/reportNoteSchema";
import {
  createReportNoteSection,
  updateReportNoteSection,
} from "app/services/report_templates/reportNoteSectionService";
import { filterNonUCHAccounts } from "utils/account.util";
import { showErrorToast, showSuccessToast } from "utils/toast";
import { REPORT_NOTE_AUTOMATED_NOTES } from "static/constants";

const ReportNoteSectionModal = (props) => {
  const {
    show,
    isEditMode,
    selectedRow,
    onCloseModal,
    fetchReportNoteSections,
  } = props;

  const { accounts } = useSelector((state) => state.account);
  const filteredAccounts = filterNonUCHAccounts(accounts);

  return (
    <ModalWrapper
      show={show}
      onClose={onCloseModal}
      title={isEditMode ? "Edit Report Note" : "Add Report Note"}
      titleStyle={{ fontWeight: 500, fontSize: 21 }}
    >
      <Formik
        initialValues={{
          _id: selectedRow?._id ?? "",
          note: selectedRow?.note ?? "",
          placeholders: selectedRow?.placeholders || [],
          associated_note: Object.keys(REPORT_NOTE_AUTOMATED_NOTES).includes(
            selectedRow?.associated_note
          )
            ? selectedRow.associated_note
            : null,
          account:
            selectedRow?.account ||
            (filteredAccounts?.length > 1
              ? selectedRow?.account
              : filteredAccounts?.[0]?.name),
        }}
        isInitialValid={false}
        validateOnChange={true}
        validateOnBlur={true}
        validationSchema={ReportNoteSectionSchema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          try {
            const { _id, note, associated_note, ...rest } = values;

            const reportNote = note?.trim();
            const associatedNote = associated_note?.trim();

            if (isEditMode) {
              await updateReportNoteSection(_id, {
                ...rest,
                note: reportNote,
                associated_note: associatedNote,
              });
            } else {
              await createReportNoteSection({
                ...rest,
                note: reportNote,
                associated_note: associatedNote,
              });
            }

            await fetchReportNoteSections();
            showSuccessToast("Report Note Section saved successfully");
          } catch (error) {
            showErrorToast(error?.message ?? error);
          } finally {
            setSubmitting(false);
            onCloseModal();
            resetForm();
          }
        }}
      >
        {(formikProps) => {
          return (
            <ReportNoteSectionInputForm
              formikProps={formikProps}
              onCloseModal={onCloseModal}
              accounts={filteredAccounts}
            />
          );
        }}
      </Formik>
    </ModalWrapper>
  );
};

export default ReportNoteSectionModal;
